import { X } from "lucide-react";
import { fmtTime } from "./advisorUtils";

// Big tap-to-open banners that slide in at the top of the desk the moment a
// customer does something. Auto-cleared by the parent after 15s.
export const DeskAlertBanner = ({ alerts, onOpen, onDismiss }) => {
  if (!alerts.length) return null;
  return (
    <div className="px-4 pt-3 space-y-2 shrink-0" data-testid="desk-alert-stack">
      {alerts.slice(0, 3).map((ev) => (
        <div
          key={ev.id}
          className="flex items-stretch rounded-2xl bg-emerald-500 text-slate-950 shadow-lg shadow-emerald-500/20 animate-in slide-in-from-top-2 fade-in duration-300"
          data-testid={`desk-alert-${ev.id}`}
        >
          <button
            type="button"
            onClick={() => onOpen(ev)}
            className="flex-1 min-w-0 text-left px-5 py-3.5 rounded-l-2xl active:bg-emerald-400"
            data-testid={`desk-alert-open-${ev.id}`}
          >
            <div className="font-black text-lg leading-tight truncate">{ev.title}</div>
            <div className="text-sm font-semibold text-emerald-950/80 truncate mt-0.5">
              {ev.body} <span className="opacity-60">· {fmtTime(ev.at)}</span>
            </div>
          </button>
          <button
            type="button"
            onClick={() => onDismiss(ev.id)}
            className="px-4 rounded-r-2xl hover:bg-emerald-400 active:bg-emerald-300"
            aria-label="Dismiss"
            data-testid={`desk-alert-dismiss-${ev.id}`}
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      ))}
    </div>
  );
};
